import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client"; // id: ID
// right_id: 権利
// start_at: 有効化日時
// end_at: 失効日時
// period_type: 期限種別
// review_flag: レビューフラグ
// suspend_flag: 一時停止フラグ
// suspend_reason: 一時停止理由
// entitled_by: 付与理由
// acquire_at: 獲得日時
// exercised_at: 初回権利行使日時
// exercise_duration: 権利行使有効期間
// exercisable_start_at: 初回権利行使可能開始日時
// exercisable_end_at: 初回権利行使可能終了日時

export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type Entitlement {\n    id: ID!\n    user_id: Int\n    right_id: Int\n    start_at: String\n    end_at: String\n    exercised_at: String\n    exercise_duration: Int\n    exercise_duration_unit: Int\n    exercisable_start_at: String\n    exercisable_end_at: String\n    entitled_by: String\n    suspend_flag: Boolean\n  }\n\n  type Query {\n    entitlements(metaId: Int): [Entitlement] @cacheControl(maxAge: 0)\n    userEntitlements: [Entitlement] @cacheControl(maxAge: 0)\n  }\n"])));
export var resolvers = {
  Query: {
    entitlements: function () {
      var _entitlements = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var metaId, dataSources, _yield$dataSources$us, _entitlements2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                metaId = _ref.metaId;
                dataSources = _ref2.dataSources;
                _context.prev = 2;
                _context.next = 5;
                return dataSources.user.entitlementsFromMeta(metaId);

              case 5:
                _yield$dataSources$us = _context.sent;
                _entitlements2 = _yield$dataSources$us.entitlements;
                return _context.abrupt("return", _entitlements2);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", null);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      }));

      function entitlements(_x, _x2, _x3) {
        return _entitlements.apply(this, arguments);
      }

      return entitlements;
    }(),
    userEntitlements: function () {
      var _userEntitlements = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _args, _ref3) {
        var req, dataSources, _yield$dataSources$us2, entitlements;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = _ref3.req, dataSources = _ref3.dataSources;

                if (!req.userToken) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 4;
                return dataSources.user.entitlements();

              case 4:
                _yield$dataSources$us2 = _context2.sent;
                entitlements = _yield$dataSources$us2.entitlements;
                return _context2.abrupt("return", entitlements);

              case 9:
                return _context2.abrupt("return", null);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function userEntitlements(_x4, _x5, _x6) {
        return _userEntitlements.apply(this, arguments);
      }

      return userEntitlements;
    }()
  },
  Entitlement: {
    id: function id(entitlment) {
      return entitlment.entitlement_id;
    }
  }
};